import { render } from "./record.vue?vue&type=template&id=59c5c07f&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=59c5c07f&scoped=true&lang=css"
import "./record.vue?vue&type=style&index=1&id=59c5c07f&lang=css"
script.render = render
script.__scopeId = "data-v-59c5c07f"

export default script